import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { queryClient } from "./queryClient";
import "./assets/styles.css";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  faEye,
  faUsers,
  faUserPlus,
  faComments,
  faPlayCircle,
  faClock,
  faChartLine,
  faChartPie,
  faRobot,
  faGlobe,
  faBell,
  faCalendarCheck,
  faFileAlt,
  faPenToSquare,
  faCheckCircle,
  faMagnifyingGlass,
  faBullhorn,
  faGear,
  faRocket,
  faLightbulb,
  faBullseye,
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
  faListCheck,
  faLink,
  faLocationDot,
  faLaptopCode,
  faFilePdf,
  faBookOpen,
  faNewspaper,
  faCircleCheck,
  faCircleExclamation,
  faSpinner,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faEye,
  faUsers,
  faUserPlus,
  faComments,
  faPlayCircle,
  faClock,
  faChartLine,
  faChartPie,
  faRobot,
  faGlobe,
  faBell,
  faCalendarCheck,
  faFileAlt,
  faPenToSquare,
  faCheckCircle,
  faMagnifyingGlass,
  faBullhorn,
  faGear,
  faRocket,
  faLightbulb,
  faBullseye,
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
  faListCheck,
  faLink,
  faLocationDot,
  faLaptopCode,
  faFilePdf,
  faBookOpen,
  faNewspaper,
  faCircleCheck,
  faCircleExclamation,
  faSpinner,
  faImage
);

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./registerServiceWorker";

import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import { MotionPlugin } from "motion-v";
import { initializeEcho } from "./services/echo";

// Create the app instance
const app = createApp(App);

// Add Pinia + Router + FloatingVue (tooltips)
app.use(createPinia());
app.use(router);
app.use(FloatingVue);
app.use(ToastPlugin);
app.use(MotionPlugin);
app.use(VueQueryPlugin, { queryClient });
app.component("FontAwesomeIcon", FontAwesomeIcon);

initializeEcho();

// Mount it to the DOM
app.mount("#app");
